<!-- Organisation leadership content -->

<!-- Magazine Design -->
<ng-container *ngIf="selectedDesign === 'magazine'">
  <fieldset class="leadership-provider-fieldset leadership-category-organisation">
    <legend class="leadership-provider-fieldset--legend">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display: inline-block; vertical-align: middle; margin-right: 8px;">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      Organisation Leaderboard
    </legend>
    
    <div class="magazine-design">
      <!-- Featured Leader (Position 1 only) -->
      <div class="magazine-featured animate-fade-in" *ngIf="topThree[0]">
        <!-- Background Organisation Icons - Multiple instances with rotations -->
        <div class="featured-background-icon featured-background-icon-1">
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div class="featured-background-icon featured-background-icon-2">
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div class="featured-background-icon featured-background-icon-3">
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div class="featured-background-icon featured-background-icon-4">
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </div>
        <div class="featured-main-grid">
          <div class="featured-col-9">
            <span class="featured-badge-top">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
              </svg>
              #1 TOP LEADER
            </span>
            <div class="featured-name-section">
              <div class="featured-name-text">
                <div class="featured-name-row-inline">
                  <h2 class="featured-name">{{ topThree[0].name }}</h2>
                  <div class="featured-crown">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                      <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" fill="#FFD700" stroke="#FFA500" stroke-width="1.5"/>
                      <circle cx="12" cy="12" r="2" fill="#FFA500"/>
                    </svg>
                  </div>
                </div>
                <p class="featured-role" *ngIf="topThree[0].members !== undefined">{{ topThree[0].members }} Members</p>
              </div>
            </div>
          </div>
          <div class="featured-col-3">
            <div class="featured-scores featured-scores--grid" *ngIf="topThree[0].totalPublished !== undefined || topThree[0].likes !== undefined || topThree[0].downloads !== undefined">
              <div class="featured-score featured-score--inline">
                <span class="score-label">Published</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5-5 5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].totalPublished ?? 0 }}</span>
                </span>
              </div>
              <div class="featured-score featured-score--inline">
                <span class="score-label">Upvotes</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].likes ?? 0 }}</span>
                </span>
              </div>
              <div class="featured-score featured-score--inline">
                <span class="score-label">Downloads</span>
                <span class="score-metric">
                  <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ topThree[0].downloads ?? 0 }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Other Leaders - Minimal Style -->
      <div class="minimal-list-wrapper">
        <div class="minimal-list">
          <div class="minimal-item animate-fade-in" *ngFor="let member of leadershipMembers.slice(1); let i = index" [style.animation-delay]="(i * 0.1 + 0.2) + 's'">
            <div class="minimal-details">
              <div class="minimal-name-row-inline">
                <h3 class="minimal-name">{{ member.name }}</h3>
                <div class="minimal-crown" *ngIf="member.rank === 2 || member.rank === 3" [class.crown-silver]="member.rank === 2" [class.crown-bronze]="member.rank === 3">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" [attr.fill]="member.rank === 2 ? '#C0C0C0' : '#CD7F32'" [attr.stroke]="member.rank === 2 ? '#808080' : '#8B4513'" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="2" [attr.fill]="member.rank === 2 ? '#808080' : '#8B4513'"/>
                  </svg>
                </div>
                <div class="minimal-rank-badge minimal-rank-star" *ngIf="member.rank > 3">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="star-icon">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                  <span class="star-rank-number">{{ member.rank }}</span>
                </div>
              </div>
              <p class="minimal-role" *ngIf="member.members !== undefined && member.members > 0">{{ member.members }} Members</p>
            </div>
            <div class="minimal-scores" *ngIf="member.totalPublished !== undefined || member.likes !== undefined || member.downloads !== undefined">
              <div class="minimal-score-card">
                <span class="score-label">Published</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5-5 5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="score-value">{{ member.totalPublished ?? 0 }}</span>
                </span>
              </div>
              <div class="minimal-score-card">
                <span class="score-label">Upvotes</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ member.likes ?? 0 }}</span>
                </span>
              </div>
              <div class="minimal-score-card">
                <span class="score-label">Downloads</span>
                <span class="score-metric">
                  <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span class="score-value">{{ member.downloads ?? 0 }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Load More Button -->
      <div class="load-more-container" *ngIf="leadershipMembers.length >= 10">
        <button 
          class="load-more-button" 
          (click)="loadMoreOrganisations()"
          [disabled]="!organisationPagination.hasNext || organisationPagination.isLoading">
          <span *ngIf="!organisationPagination.isLoading">Load More</span>
          <span *ngIf="organisationPagination.isLoading">Loading more organisations...</span>
        </button>
      </div>
    </div>
  </fieldset>
</ng-container>
